// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container';
import { Radio } from '../../../atoms/Radio';
export var RadioGroup = function (_a) {
    var options = _a.options, onChange = _a.onChange, selected = _a.selected;
    return (React.createElement(Container, { width: 'inherit', display: 'grid', gridTemplateRows: "repeat(" + options.length + ", 40px)" }, options.map(function (_a) {
        var value = _a.value, label = _a.label, disabled = _a.disabled;
        return (React.createElement(Radio, { key: value, value: value, label: label, onChange: onChange, disabled: disabled, checked: value === selected }));
    })));
};
//# sourceMappingURL=RadioGroup.js.map